"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
exports.setIsAddingToBasket = exports.setCheckoutCookie = exports.setDeliveryMethod = exports.setBasket = exports.get_checkout_cookie_thunk = exports.set_checkout_cookie_thunk = exports.get_basket_thunk = void 0;
var toolkit_1 = require("@reduxjs/toolkit");
var universal_cookie_1 = __importDefault(require("universal-cookie"));
var get_basket_1 = require("../../../api/calls/basket/get_basket");
var main_1 = require("../main");
var get_basket_thunk = (0, toolkit_1.createAsyncThunk)("basket/get_basket_thunk", function (arg, _a) {
    var dispatch = _a.dispatch, getState = _a.getState;
    return __awaiter(void 0, void 0, void 0, function () {
        var state, user, basket, response;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    state = getState();
                    user = state.userState.user;
                    basket = state.basketState.basket;
                    return [4 /*yield*/, (0, get_basket_1.get_basket)({
                            user_id: user === null || user === void 0 ? void 0 : user._id,
                            // basket_id: basket._id,
                        })];
                case 1:
                    response = _b.sent();
                    if (response.success) {
                        dispatch((0, exports.setBasket)(response.content));
                    }
                    else {
                        dispatch((0, main_1.setMessageModal)({ title: "Something went wrong while getting basket!", messages: [response.message] }));
                    }
                    return [2 /*return*/, response];
            }
        });
    });
});
exports.get_basket_thunk = get_basket_thunk;
var set_checkout_cookie_thunk = (0, toolkit_1.createAsyncThunk)("basket/set_checkout_cookie_thunk", function (arg, _a) {
    var dispatch = _a.dispatch, getState = _a.getState;
    return __awaiter(void 0, void 0, void 0, function () {
        var state, basket, cookie, cookieObj;
        var _b, _c, _d;
        return __generator(this, function (_e) {
            state = getState();
            basket = state.basketState.basket;
            cookie = new universal_cookie_1.default();
            cookieObj = {
                branch: {
                    display_name: (_b = basket === null || basket === void 0 ? void 0 : basket.branch) === null || _b === void 0 ? void 0 : _b.display_name,
                    address: (_d = (_c = basket === null || basket === void 0 ? void 0 : basket.branch) === null || _c === void 0 ? void 0 : _c.address) === null || _d === void 0 ? void 0 : _d.full_address,
                },
                basket_id: basket._id,
                user_id: basket.user_id,
                address: basket === null || basket === void 0 ? void 0 : basket.address,
                type: basket === null || basket === void 0 ? void 0 : basket.type,
                // product_list: basket?.product_list,
                // basket_obj: basket,
                delivery_fee: arg === null || arg === void 0 ? void 0 : arg.delivery_fee,
                paymentReference: arg === null || arg === void 0 ? void 0 : arg.paymentReference,
                usedVaultedCard: arg === null || arg === void 0 ? void 0 : arg.usedVaultedCard,
                discount: arg === null || arg === void 0 ? void 0 : arg.discount,
                checkoutAmount: arg === null || arg === void 0 ? void 0 : arg.checkoutAmount,
            };
            cookie.set("checked_out_basket", cookieObj, {
                sameSite: true,
            });
            dispatch((0, exports.setCheckoutCookie)(cookieObj));
            return [2 /*return*/];
        });
    });
});
exports.set_checkout_cookie_thunk = set_checkout_cookie_thunk;
var get_checkout_cookie_thunk = (0, toolkit_1.createAsyncThunk)("basket/get_checkout_cookie_thunk", function (arg, _a) {
    var dispatch = _a.dispatch, getState = _a.getState;
    return __awaiter(void 0, void 0, void 0, function () {
        var cookie, basketCookie;
        return __generator(this, function (_b) {
            cookie = new universal_cookie_1.default();
            basketCookie = cookie.get("checked_out_basket");
            dispatch((0, exports.setCheckoutCookie)(basketCookie));
            return [2 /*return*/, basketCookie];
        });
    });
});
exports.get_checkout_cookie_thunk = get_checkout_cookie_thunk;
var slice = (0, toolkit_1.createSlice)({
    name: "basket",
    initialState: {
        is_loading: false,
        add_to_basket_loading: false,
        payment_identifier: "",
        basket: null,
        product_list: [],
        delivery_method: "delivery",
        checked_out_basket: "",
    },
    reducers: {
        setBasket: function (state, action) {
            state.basket = action.payload;
        },
        setCheckoutCookie: function (state, action) {
            state.checked_out_basket = action.payload;
        },
        setIsAddingToBasket: function (state, action) {
            state.add_to_basket_loading = action.payload;
        },
        setDeliveryMethod: function (state, action) {
            state.delivery_method = action.payload;
        },
    },
    extraReducers: function (builder) {
        builder
            .addCase(get_basket_thunk.fulfilled, function (state, action) {
            state.is_loading = false;
        })
            .addCase(get_basket_thunk.rejected, function (state, action) {
            state.is_loading = false;
        })
            .addCase(get_basket_thunk.pending, function (state, action) {
            state.is_loading = true;
        });
    },
});
exports.setBasket = (_a = slice.actions, _a.setBasket), 
//setPaymentIdentifiers,
exports.setDeliveryMethod = _a.setDeliveryMethod, exports.setCheckoutCookie = _a.setCheckoutCookie, exports.setIsAddingToBasket = _a.setIsAddingToBasket;
exports.default = slice.reducer;
